<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="IMG"><img alt="" class="img90" src="images/Pilots_map2_Final_(1).jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fmmap.vue?386b03d5